import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-summary-progress-bar',
  templateUrl: './summary-progress-bar.component.html',
  styleUrls: ['./summary-progress-bar.component.scss']
})
export class SummaryProgressBarComponent implements OnInit
{
  @Input() public level: number;

  constructor() { }

  ngOnInit(): void
  {
  }

}
